import { getEntity, getEntitySubdomain, getNumericalEntityId } from '@opengov/app-core/entity/selectors';
import { userSelector } from '@opengov/app-core/session/selectors';
import { createSelector, createStructuredSelector } from '@opengov/compose-app/reselect';

import { storiesMsgs } from '../../locale';
import { EStoryLists } from '../../types';
import { IOrganizeStoriesAndFoldersProps } from '../components/Organize/OrganizeStoriesAndFolders';
import { selectStoriesPublicationFlag } from '../common/flags';
import {
  navigateToFolderList,
  navigateToOrganizeStoriesAndFolders,
  navigateToPublicationList,
  navigateToStoryList,
  navigateToTemplateList
} from '../state/navigation';

export const selectOrganizeStoriesAndFoldersProps = createStructuredSelector<
  any,
  IOrganizeStoriesAndFoldersProps
>({
  entityId: getNumericalEntityId,
  entityUuid: createSelector(getEntity, (entity) => entity.uuid),
  entitySubdomain: getEntitySubdomain,
  user: userSelector,
  messages: createSelector(storiesMsgs, (msgs) => ({ ...msgs.storyList })),
  displayPublicationTab: selectStoriesPublicationFlag,
  setSelectedList:
    () =>
      (newList, entitySubdomain, isOrganize = false, rootId) => {
        if (!entitySubdomain) return;
        switch (newList.id) {
          case EStoryLists.Stories:
            navigateToStoryList(entitySubdomain);
            break;
          case EStoryLists.Templates:
            navigateToTemplateList(entitySubdomain);
            break;
          case EStoryLists.Publications:
            navigateToPublicationList(entitySubdomain);
            break;
          default:
            isOrganize
              ? navigateToOrganizeStoriesAndFolders(entitySubdomain, newList.id, rootId)
              : navigateToFolderList(entitySubdomain, newList.id);
        }
      },
  pushToFolderList: () => (entitySubdomain, folderId) => navigateToFolderList(entitySubdomain, folderId)
});
